import React, { useState, forwardRef, useImperativeHandle } from 'react';
import Joyride from 'react-joyride';
import axios from 'axios';

const JoyrideWrapper = forwardRef((props, ref) => {
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(1); // Start from step 1
  const [activeSteps, setActiveSteps] = useState([]);
  const [activeTab, setActiveTab] =  useState();

  const stepsConfig = {
    catalog: [
      { target: '.catalog-step1', content: (
        <div className="fs-fluid">
          <strong>What’s New?</strong> <br />
          Welcome to WowLeads
        </div>
      ), placement: 'bottom', disableBeacon: true },
      { target: '.catalog-step2', content: <div className="fs-fluid">By default, the country is set to the United States of America. You can use the drop down to select India.</div>, placement: 'auto' },
      { target: '.catalog-step3', content: <div className="fs-fluid">You are now in the Catalog page. By default you see a list of our 4,500+ Categories as individual cards.</div>, placement: 'auto' },
      { target: '.catalog-step4', content: <div className="fs-fluid">Each card displays the counts of Businesses, Branches, Addresses etc.</div>, placement: 'auto' },
      { target: '.catalog-step5', content: <div className="fs-fluid">You can click on this button to toggle between Categories and States</div>, placement: 'auto' },
      { target: '.catalog-step6', content: <div className="fs-fluid">You can click on this button to toggle between Cards view and the traditional Data Grid view.</div>, placement: 'auto' },
      { target: '.catalog-step7', content: <div className="fs-fluid">You can click on this button to Refresh the data.</div>, placement: 'auto' },
      { target: '.catalog-step8', content: <div className="fs-fluid">You can click on this button to view and filter from our 4,500+ Categories in a popup window.</div>, placement: 'auto' },
      { target: '.catalog-step9', content: <div className="fs-fluid">You can also choose from a list of Category Groups (related categories grouped together).</div>, placement: 'auto' },
    ],
    businesses: [
      { target: '.business-step1', content: <div className="fs-fluid">You are now in the Businesses page. By default, each Business is listed as a Card.</div>, placement: 'auto', disableBeacon: true },
      { target: '.business-step2', content: <div className="fs-fluid">All key details related to the Business are displayed on the card.  Card’s footer section shows all Web Site and Social Media links related to respective Business.</div>, placement: 'auto' },
      { target: '.business-step3', content: <div className="fs-fluid">You can click on this button to toggle between Cards view and the traditional Data Grid view.</div>, placement: 'auto' },
      { target: '.business-step4', content: <div className="fs-fluid">This section on the side bar allows you to filter the data based on different Business attributes.</div>, placement: 'auto' },
      { target: '.business-step5', content: <div className="fs-fluid">Clicking on this button will save the current set of filters as our personalized list.</div>, placement: 'auto' },
      { target: '.business-step6', content: <div className="fs-fluid">You can select from your saved Lists using this dropdown menu.</div>, placement: 'auto' },
      { target: '.business-step7', content: <div className="fs-fluid">This sub section will show the complete detail for each selected Business.</div>, placement: 'auto' },
    ],
    people: [
      { target: '.people-step1', content: <div className="fs-fluid">You are now in the People page. By default, each Person is listed as a Card.</div>, placement: 'auto', disableBeacon: true },
      { target: '.people-step2', content: <div className="fs-fluid">All key details related to the Person are displayed on the card.  Card’s footer section shows all Web Site and Social Media links related to the Business for respective Person.</div>, placement: 'auto' },
      { target: '.people-step3', content: <div className="fs-fluid">Clicking on this button will save the current set of filters as our personalized list.</div>, placement: 'auto' },
      { target: '.people-step4', content: <div className="fs-fluid">You can select from your saved Lists using this dropdown menu.</div>, placement: 'auto' },
    ],
  };

  useImperativeHandle(ref, () => ({
    startTour: (tabName) => {
      if (stepsConfig[tabName]) {
        setActiveSteps(stepsConfig[tabName]);
        setActiveTab(tabName)
        setStepIndex(0);
        setRun(true);
      }
    },
  }));

  const handleCallback = async (data) => {
    const { status, type, index, action } = data;
  
    // End the tour if user finishes or skips
    if (['finished', 'skipped'].includes(status)) {
      const userid = parseInt(sessionStorage.getItem('userid'));
      if(status === 'finished' && userid !== 1){
        const tab = activeTab === 'catalog' ? 'iscatalogtourcompleted' : activeTab === 'businesses' ? 'isleadstourcompleted' : 'ispeopletourcompleted';
        await axios.post('/quicktipstatus', { userid, tab });
      }
      setRun(false);
      return;
    }
    
    if (type === 'error:target_not_found') {
      setStepIndex(index + 1); // jump to next step
      return;
    }

    // Only react to navigation after the step actually changes
    if (type === 'step:after') {
      if (action === 'next') {
        setStepIndex(index + 1);
      } else if (action === 'prev') {
        setStepIndex(index - 1);
      }
    }
  };
  
  

  return (
    <Joyride
      steps={activeSteps}
      run={run}
      stepIndex={stepIndex}
      continuous
      showSkipButton
      showProgress
      callback={handleCallback}
      hideCloseButton
      locale={{
        back: 'Previous',
        close: 'Close Tour',
        last: 'Finish',
        next: 'Continue',
        skip: 'Skip Tour'
      }}
      styles={{
        options: {
          arrowColor: '#C6E2F1',
          backgroundColor: '#ffffff',
          overlayColor: '#4B4A49',
          primaryColor: '#28749e',
          textColor: '#000',
          width: 400,
          zIndex: 1000,
        },
      }}
    />
  );
});

export default JoyrideWrapper;
